import { useMemo } from "react";
import { useParams } from "@/hooks/useSearchParams";
import {
  GOVERNANCE_ORG_TYPE_FILTER_PARAM,
  parseGovernanceRoleFilterParam
} from "@/pages/facilities/[facilityId]/people/governance/_utils";
import type { PersonGovernanceOrgType } from "./types";

const ORG_TYPES = new Set<PersonGovernanceOrgType>(["facility", "section", "national"]);

export function useGovernanceOrgTypeFilter() {
  const { params, addSearchParam, deleteSearchParams } = useParams();
  const selectedOrgTypes = useMemo(
    () =>
      parseGovernanceRoleFilterParam(params.orgType).filter((value): value is PersonGovernanceOrgType =>
        ORG_TYPES.has(value as PersonGovernanceOrgType)
      ),
    [params.orgType]
  );

  function onSelect(value: string, checked: boolean) {
    if (!ORG_TYPES.has(value as PersonGovernanceOrgType)) {
      return;
    }

    const next = checked
      ? [...new Set([...selectedOrgTypes, value as PersonGovernanceOrgType])]
      : selectedOrgTypes.filter((orgType) => orgType !== value);

    if (next.length === 0) {
      deleteSearchParams(GOVERNANCE_ORG_TYPE_FILTER_PARAM);
      return;
    }

    addSearchParam(GOVERNANCE_ORG_TYPE_FILTER_PARAM, next.join(","));
  }

  function onClear() {
    deleteSearchParams(GOVERNANCE_ORG_TYPE_FILTER_PARAM);
  }

  return { selectedOrgTypes, onSelect, onClear };
}
